export default "__VITE_ASSET__74b28207__"